site.magnific = {
	init: function () {
		$('.magnific-item').magnificPopup({
			type: 'iframe'
		});
	}
};

site.inits.push('site.magnific.init()');
